import * as React from "react";
export const ContactPersonIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg data-name="Layer 1" viewBox="0 0 310 358" {...props}>
    <path d="M155 0c49 0 90 40 90 90 0 49-41 89-90 89-50 0-90-40-90-89a89.626 89.626 0 0190-90zm0 25c-36 0-64 29-64 65a63.8 63.8 0 0064 64c35 0 64-29 64-64 0-36-29-65-64-65zM74 185h161c41 0 75 33 75 74v82c0 9-8 17-17 17H17c-9 0-17-8-17-17v-82a73.833 73.833 0 0174-74zm161 25H74a49.08 49.08 0 00-49 49v74h259v-74a49.08 49.08 0 00-49-49z" />
  </svg>
);
